<template>
  <div class="z-main">
    <header class="z-header">
      <div>
        <router-link to="/index">
          <img src="../../assets/sysbars/left.png">
        </router-link>
      </div>
      <div>快递单</div>
      <div>&nbsp;</div>
    </header>
    <div class="z-body z-padding10 z-body-bottom0 z-noticeDetail-content" style="width: 100%;height: 100%;">
      <div class="express d-space-row pad-all">
        <span class="label">快递公司</span>
        <input type="text" v-model="expressName">
      </div>
      <div class="express d-space-row pad-all">
        <span class="label">快递单号</span>
        <input type="number" v-model="expressNo">
      </div>
      <div class="express d-space-row pad-all">
        <span class="label">发货时间</span>
        <input type="date" v-model="time">
      </div>
      <div class="d-center-row margin-top-bottom">
        <v-btn style="border-radius: 10px;width:90%;height: 40px;box-shadow: none;" rounded color="#FF9700" dark @click="onSubmit">提交</v-btn>
      </div>
      <div class="pad-all">
        <span>退货地址：</span>
        <span>{{address}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'express',
    data() {
      return {
        expressName: '',
        expressNo: '',
        time: '',

        address:''
      }
    },
    created() {
      this.getAddress()
    },
    methods: {
      init() {
        this.expressName = ''
        this.expressNo = ''
        this.time = ''
      },
      onSubmit() {
        let params = {
          cname: this.expressName,
          express_no: this.expressNo,
          atime: this.time
        }
        this.post('api/users/addExpress', params).then((res) => {
          if (res.code == 0) {
            this.init()
          }
          this.$store.commit('layer', res.msg)
        })
      },
      getAddress(){
        this.get('api/index/consignee', {}).then((res) => {
          if (res.code == 0) {
            this.address = res.data
          }
          // this.$store.commit('layer', res.msg)
        })
      },
      onBack() {
        this.$router.go(-1);
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .express {}

  .label {
    font-size: 16px;
  }

  .express input {
    border: 1px solid #000000;
    width: 70%;
    height: 30px;
    box-sizing: border-box;
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/express.vue